/* eslint-disable @angular-eslint/component-selector */
import { Component, Input } from '@angular/core';

import { Prescription } from '../../../core/models/prescription.model';
import { NgClass, CurrencyPipe, DatePipe } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PatientNameComponent } from '../patient-name/patient-name.component';
import { CopyToClipboardComponent } from '../copy-to-clipboard/copy-to-clipboard.component';
import { PrescriberNameComponent } from '../prescriber-name/prescriber-name.component';

@Component({
    selector: '[app-prescription-list-row]',
    templateUrl: './prescription-list-row.component.html',
    styleUrls: ['./prescription-list-row.component.scss'],
    imports: [FaIconComponent,
              PatientNameComponent,
              CopyToClipboardComponent,
              PrescriberNameComponent,
              NgClass,
              CurrencyPipe,
              DatePipe]
})
export class PrescriptionListRowComponent {
  @Input() prescription: Prescription;
  @Input() showEstimatedValue: boolean;
  @Input() forProvider = false;
  @Input() collapsed: boolean;
}
